/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
console.log("Hello World! (from sd-viblock-sd-product-texture block)");
/* eslint-enable no-console */
import { store, getContext } from '@wordpress/interactivity';

store('sdViblocks', {
	actions: {
		changeTreatment() {
			const context = getContext();
			// Update the active treatment with the current treatment from this item's context
			context.activeTreatment = context.treatment;
		}
	},
	callbacks: {
		isActiveTreatment() {
			const context = getContext();
			// Check if this treatment item is the currently active one
			return context.activeTreatment.id === context.treatment.id;
		}
	}
});
